export const TRACKING_FETCH_TIMEOUT = 4000;
export const OPTED_OUT_STRING = "opted-out";
export const OPTED_OUT_NUMBER = -1;
